import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../services/api";
import "./SubwayEmployeesPage.css";

const SubwayEmployeesPage = () => {
  const { businessId, storeNumber } = useParams();
  const navigate = useNavigate();

  const [payweekEmployees, setPayweekEmployees] = useState([]);
  const [subwayEmployees, setSubwayEmployees] = useState([]);
  const [selectedMap, setSelectedMap] = useState({});
  const [loading, setLoading] = useState(true);
  const [savingId, setSavingId] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        setMessage("");
        setMessageType("");

        const [payweekRes, subwayRes] = await Promise.all([
          api.get(`/businesses/${businessId}/employees`),
          api.get(`/subway-data/store/${storeNumber}/employees`)
        ]);

        const payweekList = Array.isArray(payweekRes.data) ? payweekRes.data : [];
        const subwayList = Array.isArray(subwayRes.data) ? subwayRes.data : [];

        setPayweekEmployees(payweekList);
        setSubwayEmployees(subwayList);

        const initialSelected = {};
        subwayList.forEach((row) => {
          initialSelected[row.subway_employee_id] = row.employee_id || "";
        });
        setSelectedMap(initialSelected);
      } catch (err) {
        console.error("Error loading employee data:", err.response?.data || err.message);
        setMessage("Failed to load employee data.");
        setMessageType("error");
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [businessId, storeNumber]);

  const handleSelectChange = (subwayEmployeeId, value) => {
    setSelectedMap((prev) => ({
      ...prev,
      [subwayEmployeeId]: value
    }));
  };

  const handleSaveMapping = async (row) => {
    const selectedEmployeeId = selectedMap[row.subway_employee_id];

    if (!selectedEmployeeId) {
      setMessage("Please select a Payweek employee first.");
      setMessageType("error");
      return;
    }

    try {
      setSavingId(row.subway_employee_id);
      setMessage("");
      setMessageType("");

      await api.post("/subway-data/employee-mapping", {
  business_id: businessId,
  store_number: storeNumber,
  subway_employee_id: row.subway_employee_id,
  subway_employee_name: row.employee_name,
  employee_id: selectedEmployeeId
});

      setMessage("Employee link saved successfully.");
      setMessageType("success");

      setSubwayEmployees((prev) =>
        prev.map((item) =>
          item.subway_employee_id === row.subway_employee_id
            ? { ...item, employee_id: Number(selectedEmployeeId) }
            : item
        )
      );
    } catch (err) {
      console.error("Error saving employee mapping:", err.response?.data || err.message);
      setMessage(err.response?.data?.message || "Failed to save employee mapping.");
      setMessageType("error");
    } finally {
      setSavingId("");
    }
  };

  return (
    <div className="subway-employees-page">
      <div className="subway-employees-card">
        <div className="subway-employees-header">
          <h1 className="subway-employees-title">Link Subway Employees</h1>
          <button
            type="button"
            className="subway-employees-back-btn"
            onClick={() => navigate(`/dashboard/business/${businessId}/subway-data`)}
          >
            Back
          </button>
        </div>

        <div className="subway-employees-meta">
          <div>
            <strong>Business ID:</strong> {businessId}
          </div>
          <div>
            <strong>Store Number:</strong> {storeNumber}
          </div>
        </div>

        {message ? (
          <div
            className={`subway-employees-message ${
              messageType === "success"
                ? "subway-employees-message-success"
                : "subway-employees-message-error"
            }`}
          >
            {message}
          </div>
        ) : null}

        {loading ? (
          <div className="subway-employees-loading">Loading employees...</div>
        ) : subwayEmployees.length === 0 ? (
          <div className="subway-employees-empty">No Subway employees found.</div>
        ) : (
          <div className="subway-employees-table-wrap">
            <table className="subway-employees-table">
              <thead>
                <tr>
                  <th>Subway Employee</th>
                  <th>Subway Employee ID</th>
                  <th>Payweek Employee</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {subwayEmployees.map((row) => (
                  <tr key={row.subway_employee_id}>
                    <td>{row.employee_name}</td>
                    <td>{row.subway_employee_id}</td>
                    <td>
                      <select
                        className="subway-employees-select"
                        value={selectedMap[row.subway_employee_id] || ""}
                        onChange={(e) =>
                          handleSelectChange(row.subway_employee_id, e.target.value)
                        }
                      >
                        <option value="">Select employee</option>
                        {payweekEmployees.map((emp) => (
                          <option key={emp.id} value={emp.id}>
                            {emp.first_name} {emp.last_name}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <button
                        type="button"
                        className="subway-employees-save-btn"
                        onClick={() => handleSaveMapping(row)}
                        disabled={savingId === row.subway_employee_id}
                      >
                        {savingId === row.subway_employee_id ? "Saving..." : "Save"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default SubwayEmployeesPage;